import * as React from "react";

function SvgShare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 21.96 23.96"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M18.3 17a3.54 3.54 0 00-2.4.93l-8.69-5a3.3 3.3 0 000-1.69l8.6-4.95A3.66 3.66 0 0022 3.61a3.66 3.66 0 00-7.32 0 3.34 3.34 0 00.11.84l-8.6 5a3.67 3.67 0 00-2.49-1 3.61 3.61 0 100 7.21 3.67 3.67 0 002.49-1l8.69 5a3.35 3.35 0 00-.1.79A3.56 3.56 0 1018.3 17z" />
    </svg>
  );
}

const MemoSvgShare = React.memo(SvgShare);
export default MemoSvgShare;
